// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"182":"fcee8583","212":"76467e60","554":"88cab8d2"}[chunkId] + ".chunk.css";
};